import NotFound from './NotFound';
import Quote from './Quote';
import Services from './Services';
import Single from './Services/service';
import Projects from './Projects';
import Project from './Projects/Project';

export {
	NotFound,
	Quote,
	Services,
	Projects,
	Project,
	Single,
}
